import { ButtonProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ButtonProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ButtonProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: 'Button',
    } as ButtonProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
